import { render, staticRenderFns } from "./FoodClassAdd.vue?vue&type=template&id=6842a7da&"
import script from "./FoodClassAdd.vue?vue&type=script&lang=js&"
export * from "./FoodClassAdd.vue?vue&type=script&lang=js&"
import style0 from "./FoodClassAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports